import { createAction, props } from '@ngrx/store';
import { CommunityItemSearchFilter } from 'src/app/models/community-item-search-filter';

export const SetCommunityFilter = createAction(
    '[Community Filter] Set Community Filter',
    props<{ item: CommunityItemSearchFilter }>()
);

export const ClearCacheCommunityFilter = createAction(
    '[Community Filter] Clear Cache Community Filter'
);
